import React from 'react';
import { CarCard } from '@perxis-auto/ui-kit/lib/components/CarCard';

import mapTagsToMarkers from '@/features/cars/helpers/mapTagsToMarkers';
import { useAppSelector } from '@/features/hooks';
import { rootSelectors } from '@/features/store';
import { withHiddenLazyComponent } from '@/hoc';
import { IExtendedTag } from '@/interfaces/cars.interfaces';

import { CardMarkersProps } from './CardMarkers.types';

function CardMarkers({ data, isLoading = false }: CardMarkersProps) {
  const benefitsConfig = useAppSelector(rootSelectors.config.benefitsSelector);

  if (isLoading) {
    return <CarCard.MarkersSkeleton />;
  }

  if (!data) {
    return null;
  }

  const tags = data.data.tags || [];

  const tagsToDisplay: Array<Omit<IExtendedTag, 'collection_id'>> = [];
  tagsToDisplay.push(...tags);

  const markers = mapTagsToMarkers(tagsToDisplay);

  if (!markers.length) {
    return null;
  }

  return (
    <CarCard.Markers
      items={markers}
      mode="singleLineDynamic"
      tooltipTitle={benefitsConfig.markersTooltipTitle}
    />
  );
}

export default withHiddenLazyComponent(
  CardMarkers,
  rootSelectors.config.tagsEnableSelector,
);
